import { ActionButton } from '@fluentui/react';
import ChatButton from '../../../common/views/ChatButton';
import { Utils } from '../../../common/views/Utils';
import { ProductUtils } from '../../../products/ProductUtils';
import { ShortOrderItemModel } from '../../models/OrderModel';
import OrderTrackingView from '../shared/OrderTrackingView';
import { OrderUtils } from '../shared/OrderUtils';

export type OrderItemProps = {
    item: ShortOrderItemModel;
    onDetail: (order: ShortOrderItemModel) => void;
    onInvoiceDetail: (id: string) => void;
}

export default function OrderItemCompactView({ item, onDetail, onInvoiceDetail }: OrderItemProps) {
    let url = ProductUtils.getImageUrl(item.imageUrl);
    const total = item.price * item.qty;

    const isMobile = window.innerWidth <= 500;
    const width3 = Utils.getColumnWidth(3);
    const width4 = Utils.getColumnWidth(4);
    const width4D = Utils.getColumnWidth(4, 4, 5);
    const width8D = Utils.getColumnWidth(8, 8, 7);
    const width9 = Utils.getColumnWidth(9);

    const actionRow = () => {
        return <div className="ms-Grid-row default-toolbar">
            <div className={width4 + " left"}>
                <ChatButton />
            </div>

            <div className={width4 + " center pt-10 font-bold"}>
                $ {total.toFixed(2)}
            </div>

            <div className={width4 + " right"}>
                <ActionButton
                    iconProps={{ iconName: "NumberedListTextMirrored" }}
                    onClick={() => onDetail(item)}
                >Detail</ActionButton>
            </div>
        </div>;
    }

    const invoiceIdText = () => {
        return <div
            onClick={() => onInvoiceDetail(item.invoiceId ?? "")}
            className="pt-5 cursor gray"
            style={{ textDecoration: "underline", fontSize: "x-small" }}
        >{item.invoiceId}</div>;
    }

    return <div className="ph-15">
        <div className="ms-Grid pt-10 default-border">
            <div className="ms-Grid-row ph-5" style={{ minHeight: isMobile ? 0 : 107 }}>
                <div className={width3 + " left"}>
                    {OrderUtils.image(url, item.qty, 85, 0, false)}
                </div>
                <div className={width9}>
                    <div className="ms-Grid-row">
                        <div className={width8D + " left"}>{item.brand}</div>
                        <div className={width4D + " right"}>
                            {OrderUtils.getStatusText(item.status)}
                        </div>
                    </div>

                    <div className="ms-Grid-row pt-5 gray">
                        <div className={width8D + " left limit-lines one-line"}>{item.productName}</div>
                        <div className={width4D + " right limit-lines one-line"}>
                            {Utils.formatShortDate(item.orderDate)}
                        </div>
                    </div>

                    <div className="ms-Grid-row pt-5">
                        <div className={width8D + " left limit-lines one-line"}>
                            {ProductUtils.getSubInfoForOrder(item)}
                        </div>
                        <div className={width4D + " right limit-lines one-line"}>
                            {!Utils.isNullOrEmpty(item.invoiceId) && invoiceIdText()}
                        </div>
                    </div>

                    {OrderUtils.ShowTracking(item) && <div className="pt-10">
                        <OrderTrackingView trackings={item.trackings} />
                    </div>}
                </div>
            </div>
            <div className="pt-10">
                {actionRow()}
            </div>
        </div>
    </div>;
}